import ChartTemplate from "@/components/chart-template";
import { RevenueOverviewRow } from "@/http/api-types";
import { formatDateToMYYYY } from "@/lib/utils";
import { subMonths } from "date-fns";
import RollingRevenueSumChart from "./rolling-revenue-sum-chart";

type RevenueChartProps = {
  data: RevenueOverviewRow[];
};

function RollingRevenueSum({ data }: RevenueChartProps) {
  const previousLast12Months = (startingIndex: number) =>
    Array.from({ length: 12 }, (v, i) => {
      return formatDateToMYYYY(subMonths(new Date(), i + 1 + startingIndex));
    });

  const chartData = Array.from({ length: 12 }, (v, i) => {
    const months = previousLast12Months(i);

    return {
      revenue: data.filter(row => months.includes(row.month_year)).reduce((acc, curr) => acc + curr.revenue, 0),
      dateTime: subMonths(new Date(), i + 1).toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      }),
    };
  });

  return (
    <ChartTemplate
      timeSplittable={false}
      summaryMetric=""
      summaryMetricLabel=""
      title="Last 12 Months Rolling Revenue Sum"
      description="Compared to last 12 months trailing revenue"
      chart={<RollingRevenueSumChart chartData={chartData.reverse()} />}
      table={null}
    ></ChartTemplate>
  );
}

export default RollingRevenueSum;
